import 'angular';
import 'angular-hotkeys';
import 'angular-unsavedchanges';
import HttpAuthInterceptor from '../authentication/service/HttpAuthInterceptor';
import HttpErrorInterceptor from './errors/service/HttpErrorInterceptor';
import HttpResponseInterceptor from './errors/service/HttpResponseInterceptor';
import IInjectorService = angular.auto.IInjectorService;
import ICompileProvider = angular.ICompileProvider;
import IHttpProvider = angular.IHttpProvider;
import ILocationProvider = angular.ILocationProvider;
import ILogProvider = angular.ILogProvider;
import ITranslateProvider = angular.translate.ITranslateProvider;

configure.$inject = ['$translateProvider', '$injector', '$httpProvider', '$logProvider', '$locationProvider', '$compileProvider'];

/* @ngInject */
export function configure($translateProvider: ITranslateProvider, $injector: IInjectorService,
                          $httpProvider: IHttpProvider,
                          $logProvider: ILogProvider, $locationProvider: ILocationProvider, $compileProvider: ICompileProvider) {
    //Translation Provider configuration
    let translProp = require('../../assets/translations/translations_de.json');
    let translPropFr = require('../../assets/translations/translations_fr.json');
    let translPropIt = require('../../assets/translations/translations_it.json');

    // In case you have issues with double-escaped parameters, check out this issue:
    // https://github.com/angular-translate/angular-translate/issues/1101
    $translateProvider.useSanitizeValueStrategy('escapeParameters');

    $translateProvider
        .translations('de', translProp)
        .translations('fr', translPropFr) //add all translations at the beginning, this could maybe be done lazy
        .translations('it', translPropIt)
        .registerAvailableLanguageKeys(['de', 'fr', 'it'], {
            'de*': 'de',
            'fr*': 'fr',
            'it*': 'it',
            '*': 'de'
        })
        .fallbackLanguage('de')
        .determinePreferredLanguage();
    // remember language
    $translateProvider.useLocalStorage();

    // Dirty Check configuration (nur wenn plugin vorhanden)
    if ($injector.has('unsavedWarningsConfigProvider')) {
        let unsavedWarningsConfigProvider: any = $injector.get('unsavedWarningsConfigProvider');
        unsavedWarningsConfigProvider.useTranslateService = true;
        unsavedWarningsConfigProvider.logEnabled = false;
        unsavedWarningsConfigProvider.navigateMessage = 'UNSAVED_WARNING';
        unsavedWarningsConfigProvider.reloadMessage = 'UNSAVED_WARNING_RELOAD';
    }

    //Configuration of $http service
    $httpProvider.interceptors.push('HttpErrorInterceptor');
    $httpProvider.interceptors.push('HttpVersionInterceptor');
    $httpProvider.interceptors.push('HttpAuthInterceptor');
    $httpProvider.interceptors.push('HttpResponseInterceptor');

    $locationProvider.hashPrefix('');

    // disable debug log messages in production
    if (ENV === 'production') {
        $logProvider.debugEnabled(false);
        $compileProvider.debugInfoEnabled(false);
    } else {
        $logProvider.debugEnabled(true);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/config.ts